/**
 * Single source of truth for the OneSignal App ID.
 *
 * This is a PUBLIC browser identifier issued by OneSignal. It appears in
 * every web push payload, service worker URL, and SDK init call, and is
 * safe to ship in the client bundle (same security posture as the Mapbox
 * publishable token in `src/lib/mapbox.ts` and the Supabase publishable
 * key). It does NOT grant any ability to send pushes — only the
 * server-side `ONESIGNAL_REST_API_KEY` (Edge Function secret) can do that.
 *
 * SECURITY:
 *  - ONESIGNAL_REST_API_KEY must NEVER be imported into anything under
 *    `src/`. It lives exclusively in Supabase Edge Function secrets and is
 *    read via `Deno.env.get("ONESIGNAL_REST_API_KEY")`.
 *
 * Do NOT duplicate this value anywhere else in the codebase.
 */
export const ONESIGNAL_APP_ID = "53cfd504-ae1f-4503-9163-b9138186e8a0";

export const hasOneSignalAppId = Boolean(ONESIGNAL_APP_ID);